module.exports = __webpack_public_path__ + "img/img_pt_guide_03.efa90061.png";